import React, { Component } from "react";

import Headline from "../Headline";
import StoryBody from "../StoryBody";
import PrimaryImage from "../PrimaryImage";
import styles from "./StoryContent.css";

class StoryContent extends Component {
  render() {
    const { story, isSummary } = this.props;
    if (!story) return null;

    return (
      <div>
        {story.is_featured && !isSummary && <div className={styles.featured}>Featured</div>}
        {story.headline && <Headline headline={story.headline} permalink={story.permalink} noLink={!isSummary}/>}
        {!isSummary && <PrimaryImage image={story.primary_image} />}
        <StoryBody story={story} />
      </div>
    );
  }
}

export default StoryContent;



// WEBPACK FOOTER //
// ./src/components/Library/StoryContent/StoryContent.js